export default "__VITE_ASSET__Dbmd1dRt__"